import dayjs from 'dayjs'
import _ from 'lodash'
import {createProjectModel} from 'crm/utils/project-model'
import constants from 'crm/common/constants'
import {formatTableParams} from 'utils'
import {
    countStat,
    getStatList,
    getCustomerStat,
    getRankList,
    getMomentConfig,
    editMomentConfig,
    exportData,
    businessMomentsExport,
} from '../service'

const {dateFormat} = constants

export function getInitCountParams() {
    return {
        text_content: undefined, // 搜索内容
        type: 1, // 1:评论，2：点赞
        time: [dayjs().subtract(6, 'days').format(dateFormat), dayjs().format(dateFormat)],
    }
}
const model = createProjectModel({
    projectNamespace: 'moment',
    state: {
        countParams: getInitCountParams(),
        countData: [],
        customerStat: {},
        curRankList: [], // 本月
        preRankList: [], // 上月
        tableData: {},
        momentConfig: {},
    },
    effects: {
        *countStat(x, {select, call, put}) {
            const {countParams} = yield select((allState) => allState[model.namespace])
            const newParams = {...countParams}
            if (newParams?.time?.length) {
                newParams.publish_time_from = `${countParams.time[0]}`
                newParams.publish_time_to = `${countParams.time[1]}`
                delete newParams.time
            }

            const res = yield call(countStat, newParams)
            const data = (res && res.data) || []

            const totalData = []

            data.forEach((item) => {
                const date = item.date.substring(5)
                totalData.push({
                    name: date,
                    value: item.count,
                })
            })
            yield put({
                type: 'setProperty',
                payload: {
                    countData: totalData,
                },
            })
        },
        *getTableList(x, {select, put, call}) {
            const {tableData} = yield select((allState) => allState[model.namespace])
            const params = formatTableParams(tableData)
            const newParams = {...params}
            if (newParams?.start_time) {
                newParams.publish_time_from = params.start_time
                newParams.publish_time_to = params.end_time
                delete newParams.start_time
                delete newParams.end_time
            }

            const res = yield call(getStatList, newParams)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.tableData.dataSource = res.data
                    draft.tableData.pagination.total = _.get(res, 'pagination.rows_found', 0)
                },
            })
        },

        *getCustomerStat(x, {put, call}) {
            const res = yield call(getCustomerStat)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.customerStat = res.data
                },
            })
        },

        *getMomentConfig(x, {put, call}) {
            const res = yield call(getMomentConfig)

            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.momentConfig = res.data
                },
            })

            return res
        },

        *editMomentConfig({payload}, {call}) {
            return yield call(editMomentConfig, payload)
        },

        // 本月排行
        *getCurRankList(x, {put, call}) {
            const params = {
                limit: 6,
            }
            const res = yield call(getRankList, params)
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.curRankList = res.data
                },
            })
        },

        // 上月排行
        *getPreRankList(x, {put, call}) {
            const params = {
                limit: 6,
                st_month: dayjs().subtract(1, 'month').format('YYYY-MM'),
            }
            const res = yield call(getRankList, params)
            yield put({
                type: 'immerCb',
                payload: (draft) => {
                    draft.preRankList = res.data
                },
            })
        },

        // 导出企业任务数据
        *exportData(x, {call, select}) {
            const {tableData} = yield select((allState) => allState[model.namespace])
            const params = formatTableParams(tableData)
            const newParams = {...params}
            if (newParams?.start_time) {
                newParams.publish_time_from = params.start_time
                newParams.publish_time_to = params.end_time
                delete newParams.start_time
                delete newParams.end_time
            }
            return yield call(exportData, newParams)
        },
        // 导出朋友圈明细
        *businessMomentsExport({payload}, {call}) {
            return yield call(businessMomentsExport, payload)
        },
    },

    reducers: {
        setParams(state, action) {
            const newParams = {
                ...state.params,
                ...action.payload,
            }

            return {...state, ...{params: newParams}}
        },
        resetCountParams(state) {
            return {...state, countParams: getInitCountParams()}
        },
    },
})

export default model
